<template>
  <div>
    <card :title="warehouse ? warehouse.name : ''">
      <warehouse-products-to-order-table
        :products="products"
        :sortable="sortable"
        :hideable-columns="hideableColumns"
        @sortBy="sortBy"
      />
    </card>
  </div>
</template>

<script>
import hasPagination from 'src/has-pagination'
import WarehouseProductsToOrderTable from './warehouse-products-to-order-table'
import moment from 'moment'
import api from 'src/api'
import getSortableColumns from './get-sortable-columns'

export default {
  components: {
    WarehouseProductsToOrderTable
  },
  data () {
    return {
      api,
      warehouse: null,
      products: [],
      sortable: {
        columns: [],
        sortColumn: 'products.name',
        sortOrders: {
          'products.name': 1,
          'product_categories.name': 1,
          'units.name': 1,
          'einkaufspreis': 1,
          'products.price': 1,
          'quantity_sum': 1,
          'inventur_quantity': 1,
          'warnschwelle_config': 1,
          'soll_menge_config': 1,
          'next_expiry_date': 1
        }
      },
      hideableColumns: {
        showEkPrice: false,
        showLager: false,
        showLieferanten: false,
        showWarnschwelle: true,
        showSollMenge: true
      }
    }
  },
  mixins: [hasPagination],
  methods: {
    getData (query) {
      this.$http.get(`/warehouses/${this.$route.params.id}/products/to_order?${query}`).then(({ data }) => {
        this.products = data
      })
    },
    showProduct (stockRotation) {
      this.$router.push(`/products/${stockRotation.product.id}`)
    },
    sortBy (column) {
      this.currentPage = 1
      this.loading = true
      this.sortable.sortColumn = column
      this.sortable.sortOrders[column] = this.sortable.sortOrders[column] * -1
      this.fetchTableData()
    },
    getCustomQueryData () {
      return {
        'sort-by-column': this.sortable.sortColumn,
        'sort-by-order': this.sortable.sortOrders[this.sortable.sortColumn] > 0 ? 'ASC' : 'DESC',
      }
    },
  },
  created () {
    this.$http.get(`/warehouses/${this.$route.params.id}`).then(({ data }) => { this.warehouse = data })
    this.fetchTableData()
    this.$http.get(`/warehouses`).then(({ data }) => {
      this.hideableColumns.showEkPrice = this.$store.getters.isNotFrontdesk
      this.hideableColumns.showLager = data.length > 1
      this.hideableColumns.showLieferanten = this.$store.getters.isNotFrontdesk
      this.sortable.columns = getSortableColumns(this.hideableColumns)
    })
  }
}
</script>
